<template>
    <div id="catalog-category">
        <AppBreadCrumb :paths="[{ title: $t('message.catalogCategories') }]" :select="true">
            <div
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                :content="$t('message.showCatalogCategories')"
                class="custom-checkbox2"
            >
                <a-switch v-model="catalogVisible" size="small">
                    <a-icon slot="checkedChildren" type="check" />
                    <a-icon slot="unCheckedChildren" type="close" />
                </a-switch>
                <span>{{ $t("message.openCatalog") }}</span>
            </div>
            <a-button v-b-modal.catalog-form class="actionButtonBreadcrumb" @click="setCatalogInitialObj">
                <md-icon>add</md-icon>
                {{ $t("message.changeTitle") }}
            </a-button>
        </AppBreadCrumb>
        <b-container v-if="catalogVisible" fluid>
            <div class="col-md-12">
                <div class="titleAlign">
                    <md-button class="arrow-class" @click="back">
                        <md-icon>arrow_back</md-icon>
                    </md-button>
                    <div v-if="navigation.length" class="title">
                        {{ $_.last(navigation).languageContent[$i18n.locale].name }}
                    </div>
                    <div class="title">{{ catalogTitle }}</div>
                </div>

                <!-- Tüm menü ve içeriklerin listelendiği yer-->
                <div class="menus">
                    <div v-for="cat in catalogs" v-if="catalogs.length" class="menu">
                        <CatalogMenu :data="cat" :navigate-to="navigateTo" />
                    </div>
                </div>
                <!-- Menülerin listelendiği yerin bitişi-->

                <!-- İçeriklerin listelendiği yer-->
                <CatalogContent
                    v-if="navigation.length && navigation[navigation.length - 1].type === 'content'"
                    :data="navigation[navigation.length - 1]"
                />

                <div
                    v-if="
                        (navigation.length && navigation[navigation.length - 1].type === 'menu') || !navigation.length
                    "
                    class="newButtons"
                >
                    <!-- Yeni menü ekleme yeri (tablarla tr en alıyoruz)-->
                    <div
                        v-if="!isCreateMenu"
                        :style="isCreateContent ? 'display: none;' : ''"
                        class="newMenu"
                        @click="onCreateCatalog()"
                    >
                        {{ $t("message.addNewMenu") }}
                    </div>
                    <b-tabs v-else-if="isCreateMenu">
                        <b-tab v-for="(lang, i) in languages" :key="i" :title="lang.name">
                            <input
                                id="menuFocus"
                                v-model="catalogForm.languageContent[lang.code].name"
                                :placeholder="$t('message.pleaseTitleEnter')"
                                class="newMenu"
                                type="text"
                                @keydown="handleKeyDown"
                            />
                            <button class="actionsButtonCancel" @click="cancelMenu">
                                {{ $t("message.cancel") }}
                            </button>
                            <button class="actionsButton" @click="saveMenu">
                                {{ $t("message.save") }}
                            </button>
                        </b-tab>
                    </b-tabs>

                    <!-- Yeni içerik ekleme yeri (tablarla tr en alıyoruz)-->
                    <div
                        v-if="!isCreateContent"
                        :style="isCreateMenu ? 'display: none;' : ''"
                        class="newMenu"
                        @click="onCreateCatalog('content')"
                    >
                        {{ $t("message.content") }}
                    </div>
                    <b-tabs v-else-if="isCreateContent">
                        <b-tab v-for="(lang, i) in languages" :key="i" :title="lang.name">
                            <input
                                id="contentFocus"
                                v-model="catalogForm.languageContent[lang.code].name"
                                :placeholder="$t('message.pleaseTitleEnter')"
                                class="newMenu"
                                type="text"
                            />
                            <ckeditor
                                v-model="catalogForm.languageContent[lang.code].content"
                                :editor="editor"
                                :config="editorConfig()"
                            />
                            <button class="actionsButton" @click="cancelContent">
                                {{ $t("message.cancel") }}
                            </button>
                            <button class="actionsButton" @click="saveContent">
                                {{ $t("message.save") }}
                            </button>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </b-container>
        <div v-else>
            <a-result :title="$t('message.catalogNotOpen')">
                <template #extra>
                    <a-button type="primary" @click="catalogVisible = true">
                        {{ $t("message.openTheCatalog") }}
                    </a-button>
                </template>
            </a-result>
        </div>
        <b-modal
            id="catalog-form"
            :title="$t('message.changeTitle')"
            centered
            hide-footer
            size="lg"
            @hidden="resetTitle"
        >
            <b-row>
                <b-col md="12">
                    <b-row>
                        <b-col md="12">
                            <b-card no-body>
                                <b-tabs card no-fade>
                                    <b-tab
                                        v-for="language of languages"
                                        :key="'tab' + language.code"
                                        :title="language.name"
                                    >
                                        <b-form class="d-flex flex-column justify-content-center">
                                            <b-form-group
                                                id="catalog-input-group"
                                                :label="$t('message.catalog')"
                                                label-for="catalog-input"
                                            >
                                                <b-form-input
                                                    id="catalog-input"
                                                    v-model="catalogTitleInit[language.code]"
                                                    autocomplete="off"
                                                    trim
                                                    type="text"
                                                />
                                            </b-form-group>
                                        </b-form>
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                        </b-col>
                        <b-col md="12">
                            <div class="catalog-action-buttons">
                                <b-button style="margin-right: 6px" variant="primary" @click="handleTitleSave">
                                    {{ $t("message.update") }}
                                </b-button>
                                <b-button @click="() => this.$bvModal.hide('catalog-form')">
                                    <template>
                                        {{ $t("message.cancel") }}
                                    </template>
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-modal>
        <ChatBar v-if="!isAdmin" :visible="false" />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";
import { log2 } from "../../utils/log2";

import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import CatalogMenu from "../../components/CatalogMenu";
import CatalogContent from "../../components/CatalogContent";
import { sendSocketMessage } from "../../utils/socketStream";
import ChatBar from "../../components/ChatBar";

const initialObject = {
    languageContent: {},
    parentId: null,
    type: null,
};
const log = log2("Catalog");
const titleInitialObj = {
    en: "",
    tr: "",
};
export default {
    name: "Catalog",
    components: { CatalogContent, CatalogMenu, AppBreadCrumb, CKEditor, ChatBar },
    data() {
        return {
            editor: ClassicEditor,
            catalogForm: null,
            navigation: [],
            isCreateMenu: false,
            isCreateContent: false,
            handleSave: _.debounce((newSettings) => {
                const isValid = Date.now() - (this.mountedTime || Date.now()) > 2000; // defaulttan gerçeğe geçerken bir kere sunucuya gitmesini engellemek için alternatif başka çözüm var sa yapalım
                log("handleSave runned", {
                    newSettings,
                    initialized: this.settingInitialized,
                    isValid,
                    mountedTime: this.mountedTime,
                    diff: Date.now() - (this.mountedTime || Date.now()),
                });
                if (isValid) {
                    this.submitClicked = true;
                    const self = this;
                    this.$validator.validateAll().then((response) => {
                        if (response) {
                            self.updateSettings(newSettings)
                                .then(() => {
                                    sendSocketMessage("admin settings-updated", {
                                        siteId: self.site._id,
                                    });
                                    self.$toasted.show(self.$t("message.settingsSaved"), {
                                        duration: 3000,
                                        position: "bottom-center",
                                    });
                                })
                                .finally(() => {
                                    self.submitClicked = false;
                                });
                        } else {
                            self.$toasted.error(self.$t("message.settingFormWrong"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        }
                    });
                }
            }, 1000).bind(this),
            catalogTitleInit: titleInitialObj,
            editorConfig: () => ({
                // The configuration of the editor.
                removePlugins: ["MediaEmbed", "AutoMediaEmbed"],
            }),
        };
    },
    computed: {
        ...mapState({
            isAdmin: (state) => state.auth.adminUser != null,
            languages: (state) => state.language.languages,
            currLanguage: (state) => state.language.language,
            isDarkMod: (state) => state.app.darkMode,
            catalogs: (state) => state.catalog.catalogs,
            settings: (state) => state.setting.settings,
            settingInitialized: (state) => state.setting.initialized,
            site: (state) => state.site.site,
            defaultLang: (state) => state.setting.settings.language.clientDefault,
        }),
        getTitle() {
            return this.navigation.length
                ? _.last(this.navigation).languageContent[this.$i18n.locale].name
                : "Yardım Katalog";
        },
        catalogVisible: {
            get() {
                return this.settings.catalogVisible;
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "catalogVisible",
                    value: value,
                });

                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
        catalogTitle: {
            get() {
                let maybeCatalog = this.settings.catalogTitle.find((x) => x.languageCode === this.currLanguage.code);
                if (maybeCatalog) {
                    return maybeCatalog.content;
                }
                return "Catalog Menu";
            },
            set(value) {
                const newSettings = this.setSettingValue({
                    setting: "catalogTitle",
                    value: value,
                });
                if (newSettings.then) {
                    newSettings.then((x) => this.handleSave(x));
                } else {
                    this.handleSave(newSettings);
                }
            },
        },
    },
    methods: {
        ...mapActions({
            createCatalog: "catalog/createCatalog",
            getCatalogs: "catalog/getCatalogs",
            setSettingValue: "setting/setSettingValue",
            updateSettings: "setting/updateSettings",
        }),
        onCreateCatalog(type = "menu") {
            if (type === "menu") {
                this.isCreateMenu = true;
                setTimeout(() => {
                    document.getElementById("menuFocus").focus();
                }, 100);
            } else {
                this.isCreateContent = true;
                setTimeout(() => {
                    document.getElementById("contentFocus").focus();
                }, 100);
            }
            this.catalogForm = _.cloneDeep(initialObject);
            this.catalogForm.type = type;
            this.catalogForm.parentId = this.navigation.length ? _.last(this.navigation)._id : null;
            this.catalogForm.languageContent = this.languages.reduce((acc, cur) => {
                acc[cur.code] = {
                    name: null,
                    content: null,
                };
                return acc;
            }, {});
        },
        handleKeyDown({ code }) {
            if (code === "Enter") {
                this.createCatalog(this.catalogForm).then(() => {
                    this.isCreateMenu = false;
                    this.catalogForm = null;
                });
            }
        },
        saveContent() {
            this.createCatalog(this.catalogForm).then(() => {
                this.isCreateContent = false;
                this.catalogForm = null;
            });
        },
        saveMenu() {
            this.createCatalog(this.catalogForm).then(() => {
                this.isCreateMenu = false;
                this.catalogForm = null;
            });
        },
        cancelContent() {
            this.isCreateContent = false;
        },
        cancelMenu() {
            this.isCreateMenu = false;
        },
        navigateTo(cat) {
            log("navigateTo", cat);
            this.navigation.push(cat);
            this.getCatalogs(cat ? cat._id : null);
        },
        back() {
            log("back", {
                catalogs: this.catalogs,
                navigation: this.navigation,
            });
            this.navigation.pop();
            const last = _.last(this.navigation);
            this.getCatalogs(last ? last._id : null);
        },
        setCatalogInitialObj() {
            this.catalogTitleInit = this.settings.catalogTitle.reduce((acc, curr) => {
                acc[curr.languageCode] = curr.content;
                return acc;
            }, {});
            console.log("current deneme ", this.catalogTitleInit);
        },
        handleTitleSave() {
            let savedTitle = [];
            console.log("current deneme", this.catalogTitleInit);
            for (let lang in this.catalogTitleInit) {
                console.log("current deneme", lang);
                let langObjInit = {
                    content: this.catalogTitleInit[lang],
                    languageCode: lang,
                };
                savedTitle.push(langObjInit);
            }
            this.catalogTitle = savedTitle;
            this.$bvModal.hide("catalog-form");
        },
        resetTitle() {
            this.setCatalogInitialObj();
        },
    },
    mounted() {
        this.getCatalogs();
        this.mountedTime = Date.now();
    },
};
</script>

<style lang="scss" scoped>
#catalog-category {
    .newMenu {
        border: 1px dashed gray;
        cursor: pointer;
        padding: 10px;
        user-select: none;
        border-radius: 6px;
        width: 100%;
        margin-bottom: 10px;

        &:hover {
            background-color: #cce;
            text-decoration: underline;
        }
    }

    .menu {
        cursor: pointer;
        padding: 10px;
        user-select: none;
        border-radius: 6px;
        width: 100%;
        background-color: #fff;
        box-shadow: 0 0 3px #000000;
        margin-bottom: 10px;

        &:hover {
            background-color: #cce;
        }
    }

    .titleAlign {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 10px;
        margin: 8px 0;

        .title {
            font-size: 18px;
            font-weight: 500;
            margin-right: 100px;
        }

        .arrow-class {
            position: absolute;
            left: -35px;
        }
    }

    .actionsButton {
        padding: 6px 10px;
        margin: 8px 0;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .actionsButtonCancel {
        padding: 6px 10px;
        margin: 8px 0;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .custom-checkbox2 {
        background-color: #f3f6f9;
        border-radius: 6px;
        padding: 3px 6px;
        max-width: 120px;
        width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-family: Poppins;
        font-weight: 400;
        font-size: 12px;
        color: #1e1e2d;
        margin-right: 6px;
    }
}
</style>
<style>
.catalog-action-buttons {
    display: flex;
    margin-top: 12px;
    justify-content: flex-end;
    align-items: flex-end;
}
</style>
